module.exports = __webpack_public_path__ + "static/media/frontBackground.c2203c0b.jpg";